import PageHero from '@/components/PageHero';
import { GlassCard } from '@/components/ui/glass-card';
import { FileText, AlertCircle, Phone, Mail } from 'lucide-react';

const AGB = () => {
  const agbSections = [
    {
      title: "Anmeldung und Vertragsabschluss",
      content: [
        "Die Anmeldung zur Ausbildung erfolgt schriftlich oder telefonisch",
        "Der Vertrag kommt mit der Bestätigung der Anmeldung zustande",
        "Begrenzte Teilnehmerzahl - Anmeldungen werden nach Eingang berücksichtigt"
      ]
    },
    {
      title: "Zahlungsbedingungen",
      content: [
        "Die Kursgebühren sind vor Kursbeginn zu entrichten",
        "Ratenzahlung nach Vereinbarung möglich",
        "Bei Nichtzahlung kann der Ausschluss vom Kurs erfolgen"
      ]
    },
    {
      title: "Rücktritt und Stornierung",
      content: [
        "Rücktritt bis 14 Tage vor Kursbeginn kostenfrei möglich",
        "Bei späterem Rücktritt werden 50% der Kursgebühren fällig",
        "Bei Nichterscheinen werden die vollen Kursgebühren fällig"
      ]
    },
    {
      title: "Krankheit und Ausfall",
      content: [
        "Bei nachgewiesener Krankheit besteht die Möglichkeit zum Nachholen",
        "Nachholen ist im nächsten verfügbaren Semester möglich",
        "Ärztliches Attest ist erforderlich"
      ]
    }
  ];

  return (
    <>
      <PageHero 
        title="AGB" 
        description="Allgemeine Geschäftsbedingungen für die Prana Kundalini Akademie"
        image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
      />
      
      <section className="py-20 section-bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Introduction */}
            <GlassCard className="p-8 mb-8">
              <div className="flex items-start space-x-4">
                <FileText className="h-8 w-8 text-primary-main mt-1" />
                <div>
                  <h2 className="text-2xl font-bold text-primary-deep mb-4">
                    Allgemeine Geschäftsbedingungen
                  </h2>
                  <p className="text-gray-700">
                    Gültig für alle Ausbildungen und Behandlungen der Prana Kundalini Akademie
                  </p>
                </div>
              </div>
            </GlassCard>

            {/* AGB Sections */}
            <div className="space-y-6">
              {agbSections.map((section, index) => (
                <GlassCard key={index} className="p-6">
                  <h3 className="text-xl font-bold text-primary-deep mb-4">
                    {index + 1}. {section.title}
                  </h3>
                  <ul className="space-y-2">
                    {section.content.map((item, idx) => (
                      <li key={idx} className="flex items-start text-gray-700">
                        <span className="w-2 h-2 bg-primary-main rounded-full mr-3 mt-2 shrink-0"></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </GlassCard>
              ))}
            </div>

            {/* Important Notice */}
            <GlassCard className="p-6 mt-8 bg-orange-50 border-orange-200">
              <div className="flex items-start space-x-3">
                <AlertCircle className="h-6 w-6 text-orange-600 mt-1" />
                <div>
                  <h3 className="text-lg font-semibold text-orange-800 mb-2">
                    Wichtiger Hinweis
                  </h3>
                  <p className="text-orange-700 mb-4">
                    Diese AGB stellen eine Zusammenfassung dar. Die vollständigen Geschäftsbedingungen 
                    erhalten Sie bei der Anmeldung. Bei Fragen kontaktieren Sie uns gerne.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a 
                      href="mailto:sabrina.kure@yahoo.com"
                      className="inline-flex items-center px-4 py-2 bg-primary-main text-white rounded-lg hover:bg-primary-deep transition-colors"
                    >
                      <Mail className="mr-2 h-4 w-4" />
                      E-Mail senden
                    </a>
                    <a 
                      href="tel:+436649703314"
                      className="inline-flex items-center px-4 py-2 border border-primary-main text-primary-main rounded-lg hover:bg-primary-main hover:text-white transition-colors"
                    >
                      <Phone className="mr-2 h-4 w-4" />
                      Anrufen
                    </a>
                  </div>
                </div>
              </div>
            </GlassCard>
          </div>
        </div>
      </section>
    </>
  );
};

export default AGB;